module.exports = __webpack_public_path__ + "img/jobSel.9837914d.svg";